import { useSelector } from "react-redux";

import { RootState } from "store";

import { jwtDecode } from "jwt-decode";

export type JwtPayload = Record<string, unknown>;

export const useDecodedAccessToken = (): JwtPayload => {
  const token = useSelector((state: RootState) => state.authentication.accessToken?.access_token);
  try {
    return jwtDecode<JwtPayload>(token || "");
  } catch {
    return {};
  }
};
